import { AppStateService } from 'src/app/core/services/app-state.service'
import { MapService } from 'src/app/core/services/map.service'
import { LayerRawEventsService } from '../layers/layer-raw-events.service'
import { DataRawEventsService } from '../services/data-raw-events.service'
import { HttpClient } from '@angular/common/http'
import { AppConfigModel } from 'src/app/core/models'
import { HazardTypes } from '../enums/hazard-types.enum'
import { Layers } from '../layers-config/layers'
import { APP_CONFIG } from 'src/app/app.config'
import { Router } from '@angular/router'
import { HazardSources } from '../enums/hazard-categories.enum'
import { MapEventsService } from 'src/app/core/services/map-events.service'

export const provider1AccidentLayerProvider = {
  provide: 'provider1AccidentLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider1Accidents.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.VehicleAccident,
        HazardSources.Provider,
      ),
      15,
      undefined,
      ['#ed0007', '#007fff'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider1BDVLayerProvider = {
  provide: 'provider1BDVLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider1Bdv.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.BrokendownVehicle,
        HazardSources.Provider,
      ),
      15,
      undefined,
      ['#ffe000', '#007fff'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider1ConstructioSiteLayerProvider = {
  provide: 'provider1ConstructionSiteLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider1ConstructionSites.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.ConstructionSite,
        HazardSources.Provider,
      ),
      15,
      undefined,
      ['#34a85d', '#007fff'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider4AccidentLayerProvider = {
  provide: 'provider4AccidentLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider4Accidents.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.VehicleAccident,
        HazardSources.Provider4,
      ),
      15,
      undefined,
      ['#ed0007', '#1927bf'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider4BDVLayerProvider = {
  provide: 'provider4BDVLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider4Bdv.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.BrokendownVehicle,
        HazardSources.Provider4,
      ),
      15,
      undefined,
      ['#ffe000', '#1927bf'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider4HRLayerProvider = {
  provide: 'provider4HRLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider4HeavyRain.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.HeavyRain,
        HazardSources.Provider4,
      ),
      15,
      1,
      ['#ed0007', '#1927bf'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider4FogLayerProvider = {
  provide: 'provider4FogLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider4Fog.name,
      8,
      new DataRawEventsService(http, appState, config, HazardTypes.Fog, HazardSources.Provider4),
      15,
      0,
      ['#7ebdff', '#1927bf'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider4SlipperyLayerProvider = {
  provide: 'provider4SlipperyLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider4Slippery.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.SlipperyRoad,
        HazardSources.Provider4,
      ),
      15,
      undefined,
      ['#ffe000', '#fff'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider2AccidentLayerProvider = {
  provide: 'provider2AccidentLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider2Accidents.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.VehicleAccident,
        HazardSources.Provider2,
      ),
      15,
      undefined,
      ['#ed0007', '#088735'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider2BDVLayerProvider = {
  provide: 'provider2BDVLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider2Bdv.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.BrokendownVehicle,
        HazardSources.Provider2,
      ),
      15,
      undefined,
      ['#ffe000', '#088735'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider2ConstructioSiteLayerProvider = {
  provide: 'provider2ConstructionSiteLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider2ConstructionSites.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.ConstructionSite,
        HazardSources.Provider2,
      ),
      15,
      undefined,
      ['#34a85d', '#088735'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider3AccidentLayerProvider = {
  provide: 'provider3AccidentLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider3Accidents.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.VehicleAccident,
        HazardSources.Provider3,
      ),
      15,
      undefined,
      ['#ed0007', '#ff9cf5'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider3BDVLayerProvider = {
  provide: 'provider3BDVLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider3Bdv.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.BrokendownVehicle,
        HazardSources.Provider3,
      ),
      15,
      undefined,
      ['#ffe000', '#ff9cf5'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider3ConstructioSiteLayerProvider = {
  provide: 'provider3ConstructionSiteLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider3ConstructionSites.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.ConstructionSite,
        HazardSources.Provider3,
      ),
      15,
      undefined,
      ['#34a85d', '#ff9cf5'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider6AccidentLayerProvider = {
  provide: 'provider6AccidentLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider6Accidents.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.VehicleAccident,
        HazardSources.Provider6,
      ),
      15,
      undefined,
      ['#ed0007', '#ff7f00'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider6BDVLayerProvider = {
  provide: 'provider6BDVLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider6Bdv.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.BrokendownVehicle,
        HazardSources.Provider6,
      ),
      15,
      undefined,
      ['#ffe000', '#ff7f00'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider7AccidentLayerProvider = {
  provide: 'provider7AccidentLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider7Accidents.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.VehicleAccident,
        HazardSources.Provider7,
      ),
      15,
      undefined,
      ['#ed0007', '#a4dc35'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider7BDVLayerProvider = {
  provide: 'provider7BDVLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider7Bdv.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.BrokendownVehicle,
        HazardSources.Provider7,
      ),
      15,
      undefined,
      ['#ffe000', '#a4dc35'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider8AccidentLayerProvider = {
  provide: 'provider8AccidentLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider8Accidents.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.VehicleAccident,
        HazardSources.Provider8,
      ),
      15,
      undefined,
      ['#ed0007', '#0f90a4'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider8BDVLayerProvider = {
  provide: 'provider8BDVLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider8Bdv.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.BrokendownVehicle,
        HazardSources.Provider8,
      ),
      15,
      undefined,
      ['#ffe000', '#0f90a4'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}
export const provider8CsLayerProvider = {
  provide: 'provider8CsLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider8Cs.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.ConstructionSite,
        HazardSources.Provider8,
      ),
      15,
      undefined,
      ['#34a85d', '#0f90a4'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}
export const provider8SvLayerProvider = {
  provide: 'provider8SvLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider8Sv.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.StoppedVehicle,
        HazardSources.Provider8,
      ),
      15,
      undefined,
      ['#9f565f', '#0f90a4'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}
export const provider8WdwLayerProvider = {
  provide: 'provider8WdwLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider8Wdw.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.WrongWayDriver,
        HazardSources.Provider8,
      ),
      15,
      undefined,
      ['#9114e3', '#0f90a4'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const Provider9SvLayerProvider = {
  provide: 'Provider9SvLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider9Sv.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.StoppedVehicle,
        HazardSources.Provider9,
      ),
      15,
      undefined,
      ['#9f565f', '#c055e4'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const Provider9CsLayerProvider = {
  provide: 'Provider9CsLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRawEventsService => {
    return new LayerRawEventsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider9Cs.name,
      8,
      new DataRawEventsService(
        http,
        appState,
        config,
        HazardTypes.ConstructionSite,
        HazardSources.Provider9,
      ),
      15,
      undefined,
      ['#34a85d', '#c055e4'],
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}
